import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HeroUIProvider } from '@heroui/react';
import App from '@/App.jsx';
import User from '@context/createContext.jsx';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: 'always',
      staleTime: 300000,
      cacheTime: 600000,
      refetchOnReconnect: true,
      structuralSharing: true,
    },
  },
});

createRoot(document.getElementById('root')).render(
  <HeroUIProvider>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <User>
          <App />
        </User>
      </BrowserRouter>
    </QueryClientProvider>
  </HeroUIProvider>,
);
